// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="m20.44 21.6-7-7a6.65 6.65 0 0 1-4.22 1.45c-2.02 0-3.73-.7-5.12-2.1S2 10.86 2 8.84s.7-3.73 2.1-5.12 3.1-2.1 5.12-2.1 3.73.7 5.13 2.1 2.1 3.1 2.1 5.12A6.78 6.78 0 0 1 15 13.05l7 7-1.56 1.56ZM9.22 14.34c1.53 0 2.83-.53 3.9-1.6s1.6-2.37 1.6-3.9-.53-2.83-1.6-3.9-2.37-1.6-3.9-1.6-2.82.54-3.9 1.6-1.6 2.37-1.6 3.9.54 2.83 1.6 3.9 2.37 1.6 3.9 1.6Z" />
  </BaseIcon>
)
